import { Helmet } from 'react-helmet-async';
import { filter, stubFalse } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  MenuItem,
  TableContainer,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  Pagination,
  Button,
} from '@mui/material';
import { Dropdown, Menu } from '@mui/base';
import { MenuButton } from '@mui/base/MenuButton';
import { menuItemClasses } from '@mui/base/MenuItem';
import { styled } from '@mui/system';

import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';

import dayjs from 'dayjs';
import { validateEmployer } from '../validation/Employer';
import Deleteemployermodel from '../components/models/Employer/Deleteemployermodel';
import Addemployermodel from '../components/models/Employer/Addemployermodel';
import Employer from '../components/models/Employer/NewEmployer';
import {
  SearchEmployer,
  addEmployer,
  deleteEmployer,
  getEmployer,
  getSingleEmployer,
  updateEmployer,
} from '../redux/actions/Employeraction';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'EmployerId', label: 'EmployerId', alignRight: false },
  { id: 'EmployerName', label: 'EmployerName', alignRight: false },
  { id: 'Email', label: 'Email', alignRight: false },
  { id: 'Phone', label: 'Phone', alignRight: false },
  { id: 'CreatedAt', label: 'Created At', alignRight: false },
  { id: 'CreatedByName', label: 'Created By', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user?.name?.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis?.map((el) => el[0]);
}

export default function EmployeerPage() {
  const dispatch = useDispatch();

  // get Employer data
  const getEmployers = useSelector((state) => {
    return state?.Employer?.getEmployer?.data;
  });

  const [open, setOpen] = useState(null);
  const [modelopen, setModelOpen] = useState(false);
  const [uploadopen, setUploadopen] = useState(false);
  const [Deletemodel, setDeleteModel] = useState(stubFalse);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [Edit, setEdit] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [excelFile, setExcelFile] = useState(null);
  const [typeError, setTypeError] = useState(null);
  const [singleid, setSingleId] = useState('');
  const [state, setState] = useState([]);
  const [fielderror, setFieldError] = useState({});
  const [issubmit, setIssubmit] = useState(false);
  const [Filename, setFilename] = useState('');
  const [withdrawalData, setWithDrawalData] = useState([]);
  const [fromdate, setFromdate] = useState(dayjs().subtract(1, 'year').startOf('day'));
  const [todate, setTodate] = useState(dayjs().endOf('day'));
  const [sort, setSort] = useState(false);
  const [timeoutVal, setTimeoutVal] = useState(null);
  const [employeeData, setEmployeeData] = useState(getEmployers?.employers);

  // submit state
  const [excelData, setExcelData] = useState(null);

  const fromdata = dayjs(fromdate).format();
  const todata = dayjs(todate).format();

  const handleFilter = () => {
    dispatch(SearchEmployer(filterName, rowsPerPage, page, fromdata, todata));
    setSort(false);
  };

  useEffect(() => {
    setEmployeeData(getEmployers?.employers);
  }, [getEmployers]);

  useEffect(() => {
    if (getEmployers?.employers && getEmployers?.employers?.length > 0)
      setEmployeeData(
        getEmployers?.employers.map((item) => {
          return {
            id: item.id,
            EmployerId: item.EmployerId,
            EmployerName: item.EmployerName,
            Email: item.Email,
            Phone: item.Phone,
            CreatedAt: item.CreatedAt,
            CreatedBy: item.CreatedBy,
          };
        })
      );
  }, [getEmployers]);

  const visibleRows = useMemo(() => {
    return applySortFilter(employeeData, getComparator(order, orderBy));
  }, [employeeData, order, orderBy]);

  // popover

  const handleOpenMenu = (event, id, data) => {
    setWithDrawalData(data);
    setEdit(true);
    setSingleId(id);
    setOpen(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setOpen(null);
  };

  // upload model
  const handeluploadOpen = () => {
    setUploadopen(true);
  };
  const handleuploadClose = () => {
    setUploadopen(false);
    setOpen(false);
    setExcelData([]);
  };

  // Delete model
  const handeldeleteopen = () => setDeleteModel(true);
  const handeldeleteclose = () => {
    setDeleteModel(false);
    setOpen(false);
  };

  // model open

  const handleOpen = (id) => {
    setModelOpen(true);
    if (id) {
      setEdit(true);
      setSingleId(id);
      dispatch(getSingleEmployer(id));
    }
  };
  const handleClose = () => {
    setModelOpen(false);
    setEdit(false);
    setOpen(false);
    setState(false);
  };

  useEffect(() => {
    if (timeoutVal) {
      clearTimeout(timeoutVal);
      setTimeoutVal(null);
    }
    const timeout = setTimeout(() => {
      dispatch(SearchEmployer(filterName, rowsPerPage, page, fromdata, todata));
    }, 2000);
    setTimeoutVal(timeout);
  }, [filterName, rowsPerPage, page]);

  const singleemployer = useSelector((state) => state?.Employer?.singleEmployer);
  useEffect(() => {
    setState(singleemployer);
  }, [singleemployer]);

  const EmployeerData = [
    'EmployerName',
    'EmployerId',
    'OwnerShip',
    'Industry',
    'Address',
    'PinCode',
    'LowestSalary',
    'HighestSalary',
    'TotalSalaryOutflow',
    'Website',
    'SocialMedia',
    'Email',
    'Phone',
    'SPOCName',
    'SPOCContactInfo',
    'SOPCDesign',
    'TransactionFee',
  ];

  const handleChange = (e) => {
    const keyName = e.target.name;
    const keyValue = e.target.value;

    setState((prevState) => ({
      ...prevState,
      [keyName]: keyValue,
    }));

    if (issubmit) {
      setFieldError(validateEmployer({ ...state, [keyName]: keyValue }));
    }
  };

  const handelok = () => {
    let fields = {};
    const otherFields = Object?.keys(excelData?.[0])?.filter((fieldName) => !EmployeerData.includes(fieldName));
    if (otherFields?.length > 0) {
      otherFields?.map((e) => {
        return toast.error(`${e} is not allowed`);
      });
    }
    const filteredData = excelData?.map((items) => {
      if (!items?.EmployerName || items?.EmployerName === '') {
        toast.error('Employername is require');
      } else if (!items?.OwnerShip?.toString() || items?.OwnerShip?.toString() === '') {
        toast.error('OwnerShip is require');
      } else if (!items?.Industry || items?.Industry === '') {
        toast.error('Industry is require');
      } else if (!items?.Address || items?.Address === '') {
        toast.error('Address  is require');
      } else if (!items?.HighestSalary || items?.HighestSalary === '') {
        toast.error('HighestSalary is require');
      } else if (!items?.TotalSalaryOutflow || items?.TotalSalaryOutflow === '') {
        toast.error('TotalSalaryOutflow is require');
      } else if (!items?.Website || items?.Website === '') {
        toast.error('Website is require');
      } else if (!items?.SocialMedia || items?.SocialMedia === '') {
        toast.error('SocialMedia is require');
      } else if (!items?.Email || items?.Email === '') {
        toast.error('Email is require');
      } else if (!items?.Phone || items?.Phone === '') {
        toast.error('Phone is require');
      } else if (items?.Phone?.length === 10) {
        toast.error('Enter a valid phone number with a maximum of 10 digits');
      } else if (!items?.SPOCContactInfo || items?.SPOCContactInfo === '') {
        toast.error('SPOCContactInfo is require');
      } else if (!items?.SOPCDesign?.toString() || items?.SOPCDesign?.toString() === '') {
        toast.error('SPOCDesign is require');
      } else {
        fields = {
          EmployerName: items?.EmployerName,
          EmployerId: items?.EmployerId,
          OwnerShip: items?.OwnerShip,
          Industry: items?.Industry,
          Address: items?.Address,
          HighestSalary: items?.HighestSalary?.toString(),
          TotalSalaryOutflow: items?.TotalSalaryOutflow?.toString(),
          Website: items?.Website,
          SocialMedia: items?.SocialMedia,
          Email: items?.Email,
          Phone: items?.Phone?.toString(),
          SPOCContactInfo: items?.SPOCContactInfo,
          SPOCDesign: items?.SPOCDesign,
          TransactionFee: items?.TransactionFee,
        };
      }
      return fields;
    });

    const obj = {
      data: Object.keys(fields)?.length > 0 ? filteredData : [],
    };

    if (typeError) {
      console.log('typeError', typeError);
    } else if (obj.data?.length > 0) {
      dispatch(addEmployer(obj)).then((res) => {
        if (res.status === 200) {
          dispatch(SearchEmployer());
          setUploadopen(false);
        }
      });
      setModelOpen(false);
      setOpen(false);
    }
  };

  // for table
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = getEmployers?.employers.map((n) => n.EmployerName);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };

  // delete user
  const handeldelete = () => {
    dispatch(deleteEmployer(singleid)).then((res) => {
      if (res.status === 200) {
        dispatch(SearchEmployer());
      }
    });
    setDeleteModel(false);
    setOpen(false);
  };

  // upload file

  const handleFile = (e) => {
    const fileTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv',
    ];
    const selectedFile = e.target.files[0];
    setFilename(selectedFile?.name);
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        const reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);
          handleFileSubmit(e.target.result);
        };
      } else {
        setTypeError('Please select only excel file types');
        setExcelFile(null);
      }
    } else {
      console.log('Please select your file');
    }
  };

  // submit event
  const handleFileSubmit = (e) => {
    if (e !== null) {
      const workbook = XLSX.read(e, { type: 'buffer' });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);
      setExcelData(data);
    }
  };

  // add new Employer

  const handleaddok = () => {
    const obj = {
      data: [
        {
          EmployerName: state?.EmployerName,
          OwnerShip: state?.OwnerShip,
          Industry: state?.Industry,
          Address: state?.Address,
          HighestSalary: state?.HighestSalary,
          TotalSalaryOutflow: state?.TotalSalaryOutflow,
          Website: state?.Website,
          SocialMedia: state?.SocialMedia,
          Email: state?.Email,
          Phone: state?.Phone,
          SPOCContactInfo: state?.SPOCContactInfo,
          SPOCDesign: state?.SPOCDesign,
          TransactionFee: state?.TransactionFee,
        },
      ],
    };
    setIssubmit(true);
    const error = validateEmployer(state);
    if (Object.keys(error).length === 0) {
      dispatch(addEmployer(obj));
      setModelOpen(false);
      setOpen(false);
      setEdit(false);
    } else {
      console.log('Error:', error);
    }
    setFieldError(validateEmployer(state));
  };

  // edit Employer

  const handleeditok = () => {
    const obj = {
      EmployerName: state?.EmployerName,
      OwnerShip: state?.OwnerShip,
      Industry: state?.Industry,
      Address: state?.Address,
      HighestSalary: state?.HighestSalary,
      TotalSalaryOutflow: state?.TotalSalaryOutflow,
      Website: state?.Website,
      SocialMedia: state?.SocialMedia,
      Email: state?.Email,
      Phone: state?.Phone,
      SPOCContactInfo: state?.SPOCContactInfo,
      SPOCDesign: state?.SPOCDesign,
      TransactionFee: state?.TransactionFee,
    };
    setIssubmit(true);
    const error = validateEmployer(state);
    if (Object.keys(error).length === 0) {
      dispatch(updateEmployer(singleid, obj)).then((res) => {
        if (res.status === 200) {
          setModelOpen(false);
          setOpen(false);
          setEdit(false);
          dispatch(SearchEmployer());
        } else {
          toast.error(res?.response?.data?.message);
        }
      });
    } else {
      console.log('Error:', error);
    }
    setFieldError(validateEmployer(state));
  };

  // selector for  add emp and uplodfile model

  const handleSelect = (e) => {
    const { value } = e.target;
    if (value === 'employee') {
      handleOpen();
    } else if (value === 'upload') {
      handeluploadOpen();
    }
  };

  // table data

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - getEmployers?.employers.length) : 0;

  const filteredUsers = applySortFilter(getEmployers?.employers, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers?.length && !!filterName;

  const blue = {
    100: '#DAECFF',
    200: '#99CCF3',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
  };

  const grey = {
    50: '#f6f8fa',
    100: '#eaeef2',
    200: '#d0d7de',
    300: '#afb8c1',
    400: '#8c959f',
    500: '#6e7781',
    600: '#57606a',
    700: '#424a53',
    800: '#32383f',
    900: '#24292f',
  };

  const StyledListbox = styled('ul')(
    ({ theme }) => `
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    box-sizing: border-box;
    padding: 6px;
    margin: 5px 0;
    min-width: 150px;
    border-radius: 12px;
    overflow: auto;
    outline: 0px;
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    box-shadow: 0px 4px 30px ${theme.palette.mode === 'dark' ? grey[900] : grey[200]};
    z-index: 1;
    `
  );

  const StyledMenuItem = styled(MenuItem)(
    ({ theme }) => `
    list-style: none;
    padding: 8px;
    border-radius: 8px;
    cursor: default;
    user-select: none;
  
    &:last-of-type {
      border-bottom: none;
    }
  
    &.${menuItemClasses.focusVisible} {
      outline: 3px solid ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    }
  
    &.${menuItemClasses.disabled} {
      color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
    }
  
    &:hover:not(.${menuItemClasses.disabled}) {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
      color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    }
    `
  );

  const TriggerButton = styled(MenuButton)(
    ({ theme }) => `
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    font-weight: 600;
    box-sizing: border-box;
    min-height: calc(1.5em + 22px);
    border-radius: 7px;
    padding: 8px 10px;
    line-height: 1.5;
    background: ${theme.palette.mode === 'dark' ? '#2065D1' : '#2065D1'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    color: ${theme.palette.mode === 'dark' ? 'white' : 'white'};
  
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
    `
  );

  const header = [
    {
      name: 'abc',
      age: 20,
      email: 'test@gmail.com',
    },
  ];

  return (
    <>
      <Helmet>
        <title> User | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Employer
          </Typography>

          {/* upload */}
          <Employer
            uploadopen={uploadopen}
            handleFileSubmit={handleFileSubmit}
            handleFile={handleFile}
            excelFile={excelFile}
            handelok={handelok}
            typeError={typeError}
            Filename={Filename}
            handleuploadClose={handleuploadClose}
          />
          {/* edit */}
          <Addemployermodel
            withdrawalData={withdrawalData}
            fielderror={fielderror}
            handleChange={handleChange}
            modelopen={modelopen}
            state={state}
            handleClose={handleClose}
            handelok={handelok}
            handleeditok={handleeditok}
            handleaddok={handleaddok}
            Edit={Edit}
            Filename={Filename}
            typeError={typeError}
            handleFileSubmit={handleFileSubmit}
            handleFile={handleFile}
          />
          <div style={{ display: 'flex', gap: '10px' }}>
            <Dropdown>
              <TriggerButton sx={{ backgroundColor: '#2065D1' }}>Add Employer</TriggerButton>
              <Menu slots={{ listbox: StyledListbox }}>
                <StyledMenuItem onClick={() => handleOpen()}>Add Employer</StyledMenuItem>
                <StyledMenuItem onClick={() => handeluploadOpen()}>Upload file</StyledMenuItem>
              </Menu>
            </Dropdown>
            <Button variant="contained">
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={getEmployers?.employers !== undefined ? getEmployers?.employers : []}
                filename="users.csv"
                target=""
              >
                Download CSV
              </CSVLink>
            </Button>
          </div>
        </Stack>

        {/* add bulk employet */}

        {/*  */}
        <Card>
          <UserListToolbar
            name="Employer"
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            typeError={typeError}
            setFromdate={setFromdate}
            setTodate={setTodate}
            handleFilter={handleFilter}
            sort={sort}
            setSort={setSort}
          />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, minHeight: 300 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={getEmployers?.count}
                  numSelected={selected?.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {visibleRows?.map((row, index) => {
                    const {
                      id,
                      EmployerId,
                      EmployerName,
                      Phone,
                      CreatedAt,
                      CreatedByName,
                      Email,
                      Employer,
                      imageUrl,
                      isVerified,
                    } = row;
                    const selectedUser = selected.indexOf(EmployerName) !== -1;

                    return (
                      <TableRow hover key={index} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell onClick={() => handleOpen(EmployerId)} sx={{ cursor: 'pointer' }} align="left">
                          {EmployerId}
                        </TableCell>
                        <TableCell
                          onClick={() => handleOpen(EmployerId)}
                          sx={{ cursor: 'pointer' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {EmployerName}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell
                          onClick={() => handleOpen(EmployerId)}
                          sx={{ cursor: 'pointer' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {Email}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell onClick={() => handleOpen(EmployerId)} sx={{ cursor: 'pointer' }} align="left">
                          {Phone}
                        </TableCell>
                        <TableCell onClick={() => handleOpen(EmployerId)} sx={{ cursor: 'pointer' }} align="left">
                          {CreatedAt ? dayjs(CreatedAt).format('YYYY-MM-DD') : ''}
                        </TableCell>
                        <TableCell onClick={() => handleOpen(EmployerId)} sx={{ cursor: 'pointer' }} align="left">
                          {CreatedByName}
                        </TableCell>
                        <TableCell sx={{ cursor: 'pointer' }} align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={(e) => handleOpenMenu(e, EmployerId, row?.withdrawalData)}
                          >
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>
                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          {/* <Pagination count={10} page={page} onChange={handleChangePage} /> */}

          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 150]}
            component="div"
            count={getEmployers?.employers?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <CSVLink style={{ color: '#212B36', textDecoration: 'none' }} data={header} filename="sample.csv" target="">
          <MenuItem>
            <Iconify icon={'material-symbols:cloud-download'} sx={{ mr: 2 }} />
            Download
          </MenuItem>
        </CSVLink>
        <MenuItem onClick={() => handleOpen(singleid)}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem onClick={handeldeleteopen} sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>

        {/* delete model */}

        <Deleteemployermodel
          Deletemodel={Deletemodel}
          handeldeleteclose={handeldeleteclose}
          handeldelete={handeldelete}
        />
      </Popover>
    </>
  );
}
